<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="12">
          <v-card class="rounded-xl">
            <v-overlay absolute style="opacity: 0.6" :value="isLoadingSolution">
              <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
            </v-overlay>
            <v-card-title>
              <v-row style="justify-content: space-between">
                <v-card-title class="title-displays"> Hidrometros </v-card-title>
                <v-card-title>
                  <v-btn right @click="openSolutionDialog()" color="primary" text>
                    <v-icon> add </v-icon>
                    Nova Hidrometro
                  </v-btn>
                </v-card-title>
              </v-row>
            </v-card-title>
            <v-card style="overflow: hidden">
              <v-row style="justify-content: space-between">
                <v-text-field style="width:80%; padding:1em" class="px-4" prepend-icon="search" label="Busca"
                  v-model="searchText"></v-text-field>
                <v-select hint="Buscar nessa coluna" persistent-hint style="width:20%; padding: 1em" item-text="text"
                  item-value="value" v-model="columnToSeach" :items="columnsToChoose" hide-details
                  single-line></v-select>
              </v-row>

              <v-data-table :headers="headers" :items="filterSoluitions" no-data-text="Sem soluções para exibir"
                :footer-props="{
                  'items-per-page-options': [5, 10, 20, 30]
                }" :page.sync="page" :items-per-page="10">
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="(item, i) in items" :key="i" style="height: 100%;color: #1976d2">

                      <td>
                        <v-card-text class="units-table-names">{{ item.name }}</v-card-text>
                      </td>
                      <td>
                        <v-card-text class="units-table-names">{{ item.model }}</v-card-text>
                      </td>
                      <td>
                        <v-card-text class="units-table-names">{{ item.litersPerPulse }}</v-card-text>
                      </td>

                      <td style="width: 100px;">
                        <v-card-text style="white-space: normal">
                          <v-btn @click="openSolutionDialog(item)" v-ripple>
                            <v-icon small color="primary" class="mr-2">
                              mdi-pencil
                            </v-icon>
                          </v-btn>
                          <v-btn @click="confirmDeleteHydrometer(item)" v-ripple>
                            <v-icon small color="primary"> mdi-delete </v-icon>
                          </v-btn>
                        </v-card-text>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <v-dialog persistent width="600" v-model="dialogSolution" v-if="dialogSolution">
      <v-card>
        <v-card-title class="primary lighten white--text">{{
          formTitle
        }}
          <v-spacer></v-spacer>
          <v-btn class="litte white--text" text @click="dialogSolution = false">
            <v-icon white>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="addSolutionForm" v-model="validForm" lazy-validation>
            <v-overlay absolute style="opacity: 0.6" :value="isLoadingSolutionForm">
              <v-progress-circular indeterminate color="primary" :size="50" />
            </v-overlay>
            <v-row>
              <v-col cols="12">
                <v-text-field outlined label="Nome" v-model="newItem.name" :rules="rulesRequired" />
              </v-col>
              <v-col cols="8">
                <v-text-field outlined label="Modelo" v-model="newItem.model" :rules="rulesRequired" />
              </v-col>
              <v-col cols="4">
                <v-text-field outlined label="Pulso / Litro" v-model="newItem.litersPerPulse" :rules="rulesRequired" />
              </v-col>
              <v-col cols="12">
                <v-textarea outlined label="Descrição" v-model="newItem.description" />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="saveSolution" :loading="false" text :disabled="!validForm" color="primary">
            Salvar
          </v-btn>
        </v-card-actions>
        <v-overlay absolute v-model="saveButtonLoading">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import HydrometersScript from './HydrometersScript';
export default HydrometersScript;
</script>


<style></style>